<div class="table-container">
  <ng-container
    *ngIf="gradingPeriod?.units?.length; else noUnits"
  ></ng-container>
  <table
    mat-table
    [dataSource]="dataSource"
    *ngIf="gradingPeriod?.units?.length && columnIdList.length"
  >
    <tr mat-header-row *matHeaderRowDef="columnIdList; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columnIdList"></tr>
    <ng-container
      *ngFor="let col of displayedColumns; trackBy: 'columnIndex' | trackByKey"
      [matColumnDef]="col.columnId"
      [sticky]="isSticky(col)"
    >
      <th mat-header-cell *matHeaderCellDef>
        <ng-container *ngIf="col.columnId.includes('unit'); else notUnit">
          <div class="p-10" [class.highlighted]="col.highlight">
            <span [title]="col.columnName">
              {{ col.columnName | uppercase | truncateText: 21 }}
            </span>
          </div>
        </ng-container>
        <ng-template #notUnit>
          {{ col.columnName | uppercase }}
        </ng-template>
        <div
          *ngIf="col.columnId.includes('unit')"
          class="img-container"
          (click)="goToGradeView(col.columnId)"
        >
          <img [src]="col.url" [alt]="col.label" />
        </div>
      </th>
      <td mat-cell *matCellDef="let row">
        <div
          class="cell-text"
          *ngIf="col.columnId === 'skills' && !scoreGradingPeriod"
        >
          <ng-container>
            <div *ngFor="let rubricSkill of gradingPeriod?.rubricSkills">
              {{ rubricSkill.description }}
            </div>
          </ng-container>
        </div>
        <div
          class="cell-text"
          *ngIf="col.columnId.includes('overall') && !scoreGradingPeriod"
        >
          <ng-container>
            <div *ngFor="let score of row[col.columnId]?.scores">
              {{ score }}
            </div>
          </ng-container>
        </div>
        <div
          class="cell-text"
          *ngIf="col.columnId.includes('unit') && !scoreGradingPeriod"
        >
          <ng-container>
            <div *ngFor="let rubricSkill of gradingPeriod?.rubricSkills">
              {{ getSkillScore(rubricSkill, row[col.columnId]) }}
            </div>
          </ng-container>
        </div>
        <div
          *ngIf="col.columnId.includes('name') || scoreGradingPeriod"
          class="cell-text"
          [ngClass]="{ 'centered-value': !col.columnId.includes('name') }"
        >
          <ng-container>
            {{ row[col.columnId] | uppercase }}
          </ng-container>
        </div>
      </td>
    </ng-container>
  </table>
  <ng-template #noUnits>
    There is no grading information for this grading period
  </ng-template>
</div>
